import { useMemo } from "react";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import getRoutes from "../model/routes";
import { User } from "../../../entities/me";

type AppRouterProps = {
  user: User | null | undefined;
};

export const AppRouter: React.FC<AppRouterProps> = ({ user }) => {
  const router = useMemo(() => {
    const routes = getRoutes(user);
    return createBrowserRouter(routes);
  }, [user]);

  return <RouterProvider router={router} />;
};
